import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getRealEstateRegistryList as getRealEstateRegistryListApi,
	getRealEstateRegistryListQuery as getRealEstateRegistryListQueryApi,
	getRealEstateRegistry as getRealEstateRegistryApi,
	addNewRealEstateRegistryApi,
	updateRealEstateRegistryApi,
	deleteRealEstateRegistryApi,
	checkRealEstateRegistryExistsApi,
} from '../../helpers/real_estate_registry/api_helper';

export const getRealEstateRegistryList = createAsyncThunk(
	'realEstateRegistry/getRealEstateRegistryList',
	async () => {
		try {
			const response = await getRealEstateRegistryListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los conservadores de bienes raíces.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getRealEstateRegistryListQuery = createAsyncThunk(
	'realEstateRegistry/getRealEstateRegistryListQuery',
	async params => {
		try {
			const response = getRealEstateRegistryListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getRealEstateRegistry = createAsyncThunk(
	'realEstateRegistry/getRealEstateRegistry',
	async real_estate_registry_id => {
		try {
			const response = await getRealEstateRegistryApi(real_estate_registry_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el conservador de bienes raíces.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewRealEstateRegistry = createAsyncThunk(
	'realEstateRegistry/addNewRealEstateRegistry',
	async real_estate_registry => {
		try {
			const response = await addNewRealEstateRegistryApi(real_estate_registry);
			toast.success('Conservador de Bienes Raíces agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el conservador de bienes raíces.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateRealEstateRegistry = createAsyncThunk(
	'realEstateRegistry/updateRealEstateRegistry',
	async real_estate_registry => {
		try {
			const response = await updateRealEstateRegistryApi(real_estate_registry);
			toast.success('Conservador de Bienes Raíces actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el conservador de bienes raíces.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteRealEstateRegistry = createAsyncThunk(
	'realEstateRegistry/deleteRealEstateRegistry',
	async real_estate_registry => {
		try {
			const response = await deleteRealEstateRegistryApi(real_estate_registry._id);
			toast.success('Conservador de Bienes Raíces eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return real_estate_registry;
		} catch (error) {
			toast.error('Error al eliminar el conservador de bienes raíces.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkRealEstateRegistryExists = createAsyncThunk(
	'realEstateRegistry/checkRealEstateRegistryExists',
	async name => {
		try {
			const response = await checkRealEstateRegistryExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
